import React from 'react';
import { Button } from 'reactstrap';
import { auth } from '../../Api';
import { formatServerMessage } from '../../utils/serverErrors';

// The "On / Off duty history" section of the Guard Information page: the guard's state now, then each
// change (On duty / Off duty, who with their role, when), newest first, 10 a page. Times are in the
// guard's company time zone, which the server names.
export default function GuardDutyHistory({ guardId }) {
	const [page, setPage] = React.useState(1);
	const [data, setData] = React.useState(null);
	const [error, setError] = React.useState(null);

	React.useEffect(() => {
		let current = true;
		setError(null);
		auth.getGuardDutyHistory({ id: guardId, page: page })
			.then((res) => {
				if (!current) return;
				if (res && res.data && res.data.code === 200) {
					setData(res.data);
				} else {
					setError(formatServerMessage(res && res.data ? res.data.message : null, 'The history could not be loaded.'));
				}
			})
			.catch(() => current && setError('The history could not be loaded.'));
		return () => { current = false; };
	}, [guardId, page]);

	if (error) {
		return <div className="text-danger">{error}</div>;
	}
	if (!data) {
		return <div>Loading</div>;
	}
	const rows = data.rows || [];
	const pages = data.pages || 1;
	return (
		<div>
			<div style={{ marginBottom: 10 }}>
				<strong>Now: </strong>
				{data.on_duty
					? <span style={{ color: '#1e7b34', fontWeight: 600 }}>On duty</span>
					: <span style={{ color: '#b00020', fontWeight: 600 }}>Off duty{data.off_duty_since ? ' since ' + data.off_duty_since : ''}</span>}
				<span style={{ color: '#666', marginLeft: 8, fontSize: '0.85em' }}>(times in {data.timezone})</span>
			</div>
			{data.total === 0 ? (
				<div style={{ color: '#666' }}>No changes yet</div>
			) : (
				<div>
					<table className="table table-sm" style={{ maxWidth: 700 }}>
						<thead>
							<tr><th>Change</th><th>By</th><th>Date and time</th></tr>
						</thead>
						<tbody>
							{rows.map((row, index) => (
								<tr key={index}>
									<td style={{ color: row.on_duty ? '#1e7b34' : '#b00020', fontWeight: 600 }}>{row.on_duty ? 'On duty' : 'Off duty'}</td>
									<td>{row.by}</td>
									<td>{row.at}</td>
								</tr>
							))}
						</tbody>
					</table>
					<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
						<Button size="sm" disabled={page <= 1} onClick={() => setPage(page - 1)}>Previous</Button>
						<span>Page {Math.min(page, pages)} of {pages}</span>
						<Button size="sm" disabled={page >= pages} onClick={() => setPage(page + 1)}>Next</Button>
					</div>
				</div>
			)}
		</div>
	);
}
